const MAILCHIMP_AUDIENCE_ID = process.env.REACT_APP_MAILCHIMP_AUDIENCE_ID;

class Mailchimp {
  constructor() {
    this.initialized = false;
    this.audienceId = MAILCHIMP_AUDIENCE_ID;
    this.userQueue = [];
  }

  init() {
    if (this.initialized || !this.audienceId) return;

    this.initialized = true;
  }

  track(eventName, parameters = {}) {
    if (!this.initialized) return;

    const trackingData = {
      event: eventName,
      properties: parameters,
      timestamp: new Date().toISOString()
    };

    if (window._mcq) {
      window._mcq.push(["track", eventName, parameters]);
    }

    console.log("Mailchimp track:", trackingData);
  }

  page(pagePath, pageTitle) {
    if (!this.initialized) return;

    const pageData = {
      path: pagePath || window.location.pathname,
      title: pageTitle || document.title,
      url: window.location.href,
      timestamp: new Date().toISOString()
    };

    if (window._mcq) {
      window._mcq.push(["trackPageView", pageData]);
    }

    console.log("Mailchimp page view:", pageData);
  }

  identify(userId, traits = {}) {
    if (!this.initialized) return;

    const userData = {
      email: traits.email,
      merge_fields: {
        FNAME: traits.firstName || traits.firstname || "",
        LNAME: traits.lastName || traits.lastname || "",
        PHONE: traits.phone || "",
        ADDRESS: {
          addr1: traits.street || "",
          city: traits.city || "",
          state: traits.state || "",
          zip: traits.postal_code || traits.postalCode || "",
          country: traits.country || "US"
        }
      },
      status: "subscribed",
      tags: traits.tags || [],
      timestamp_signup: new Date().toISOString()
    };

    if (userId) {
      userData.unique_email_id = userId;
    }

    this.userQueue.push(userData);

    if (window._mcq) {
      window._mcq.push(["identify", userData]);
    }

    console.log("Mailchimp identify:", userData);
  }

  subscribeUser(email, firstName = "", lastName = "") {
    if (!this.initialized) return;

    const subscriptionData = {
      email_address: email,
      status: "subscribed",
      merge_fields: {
        FNAME: firstName,
        LNAME: lastName
      }
    };

    if (window._mcq) {
      window._mcq.push(["subscribe", subscriptionData]);
    }

    console.log("Mailchimp subscribe:", subscriptionData);
  }
}

export default new Mailchimp();
